import React from "react";
import { useSelector } from "react-redux";
import { selectAllFormSettings } from "../../redux/slices/formSettingsSlice";
import PrivacyOptionsControl from "./PrivacyOptionsControl";

/**
 * @param {object} props - Component properties
 * @param {number} props.controlId - The ID of the CMS control to retrieve settings
 * @returns {React.ReactElement} The ConnectedPrivacyOptionsControl component.
 */
const ConnectedPrivacyOptionsControl = ({ controlId }) => {
    const { isStandardDonationForm = 0 } = useSelector(selectAllFormSettings);
    const shouldUseInvertedOptions = !!isStandardDonationForm;
    return (
        <PrivacyOptionsControl
            shouldUseInvertedOptions={shouldUseInvertedOptions}
            controlId={controlId}
        />
    );
};

export default ConnectedPrivacyOptionsControl;
